import {WpEtEnrollment} from "./wp-et-enrollment.model";

export class EnrollmentSumary {
  constructor(
    public etEnrollment?: WpEtEnrollment,
    public providerId?: number,
    public changeProvider?: String,
    public countyId?: number,
    public changeCounty?: String,
    public empStatusCd?: String,
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/EnrollmentSumary.ts